/* eslint-disable react/prop-types */
// React
import React from 'react';
// PropType
import PropTypes from 'prop-types';
// translation
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
// MUI
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
// Components
import { ADGMAlert, ADGMImage } from 'aurora-components';
// Utils
import { keyEmptyCheck } from 'aurora-utils/utils';
// styles
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import styles from './styles';

const TawtheeqRegistrationFees = ({
  classes,
  isEditable = false,
  registrationFeeDetails,
  handleCheck,
  feeCharges,
  application,
}) => {
  const isChecked = registrationFeeDetails?.enrollPropertyInTawteeq;

  const isVilla = feeCharges?.isVilla;

  const isBuildingRegistered = application?.isParentRegistered;

  const showTawteeqSection = application?.feeCharges?.showTawteeqSection;

  function getTotalText() {
    const Total = isBuildingRegistered
      ? feeCharges?.unitRegFeeAmount
      : feeCharges?.propertyRegFeeAmount + feeCharges?.unitRegFeeAmount;
    return <FormattedMessage {...messages.AED_amount} values={{ num: Total }} />;
  }

  return (
    showTawteeqSection && (
      <Paper variant='outlined' className={classes.paperCardFrame}>
        <div className={classes.titleHead}>
          <Typography variant='h6' component='h1' className={classes.title}>
            <FormattedMessage {...messages.tawtheeq_registration_fees} />
          </Typography>
        </div>
        <Box className={classNames(classes.innerCard)}>
          {isEditable && (
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'
              className={classNames(classes.checkBoxContainer, isChecked && 'checked')}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      classes={{
                        root: classes.itemCheckbox,
                        checked: classes.itemCheckboxChecked,
                        indeterminate: classes.itemCheckboxIndeterminate,
                      }}
                      onChange={handleCheck}
                      checked={isChecked}
                    />
                  }
                  label={
                    <span className={classes.checkBoxTitle}>
                      <FormattedMessage {...messages.enroll_property_in_tawtheeq} />
                    </span>
                  }
                />
              </FormGroup>
              {isChecked && <span className={classes.Totalprice}> {getTotalText()}</span>}
            </Box>
          )}

          {isChecked && isEditable && (
            <Box>
              <TawtheeqBodyGenerator
                isEditable
                feeCharges={feeCharges}
                classes={classes}
                isVilla={isVilla}
                isBuildingRegistered={isBuildingRegistered}
              />

              <Box
                display='flex'
                alignItems='center'
                justifyContent='space-between'
                mt={2}
                className={classes.totalContainer}
              >
                <span>
                  <FormattedMessage {...messages.total_to_be_paid} />
                </span>

                <span>{getTotalText()}</span>
              </Box>
            </Box>
          )}

          {!isEditable && (
            <Box>
              <TawtheeqBodyGenerator
                feeCharges={feeCharges}
                classes={classes}
                isVilla={isVilla}
                isBuildingRegistered={isBuildingRegistered}
              />
              <Box
                display='flex'
                alignItems='center'
                justifyContent='space-between'
                mt={2}
                className={classes.totalContainer}
              >
                <span>
                  <FormattedMessage {...messages.total_to_be_paid} />
                </span>
                <span>{getTotalText()}</span>
              </Box>
            </Box>
          )}
        </Box>
      </Paper>
    )
  );
};

// =======================================================

function TawtheeqBodyGenerator({ classes, isEditable = false, isVilla, isBuildingRegistered, feeCharges }) {
  if (isVilla) {
    return isEditable ? (
      <Box className={classes.feesResult}>
        <Box display='flex' alignItems='center' justifyContent='space-between' my={1} className={classes.feesText}>
          <span>
            <FormattedMessage {...messages.registration_fees_of_property_details} />
          </span>
          <span>
            <FormattedMessage {...messages.AED_amount} values={{ num: feeCharges?.propertyRegFeeAmount }} />
          </span>
        </Box>
        <Box display='flex' alignItems='center' justifyContent='space-between' my={1} className={classes.feesText}>
          <span>
            <FormattedMessage {...messages.registration_fees_of_rental_unit_details} />
          </span>
          <span>
            <FormattedMessage {...messages.AED_amount} values={{ num: feeCharges?.unitRegFeeAmount }} />
          </span>
        </Box>
        {/* Notfication */}

        <NotficationGenerator classes={classes} Villa />
      </Box>
    ) : (
      <Box className={classes.feesResult}>
        {/* Registration Fees of Property Details */}
        <RegFeesOfPropertyDetailsNotEditable classes={classes} feeCharges={feeCharges} />

        {/* Registration Fees of Rental Unit Details */}
        <RegFeesOfUnitDetailsNotEditable classes={classes} feeCharges={feeCharges} />
      </Box>
    );
  }
  if (isBuildingRegistered) {
    return isEditable ? (
      <Box className={classes.feesResult}>
        <Box display='flex' alignItems='center' justifyContent='space-between' my={1} className={classes.feesText}>
          <span>
            <FormattedMessage {...messages.registration_fees_of_rental_unit_details} />
          </span>
          <span>
            <FormattedMessage {...messages.AED_amount} values={{ num: feeCharges?.unitRegFeeAmount }} />
          </span>
        </Box>
        {/* Notfication */}
        <NotficationGenerator classes={classes} Unit />
      </Box>
    ) : (
      <Box className={classes.feesResult}>
        {/* Registration Fees of Rental Unit Details */}
        <RegFeesOfUnitDetailsNotEditable classes={classes} feeCharges={feeCharges} />
      </Box>
    );
  }
  if (!isBuildingRegistered) {
    return isEditable ? (
      <Box className={classes.feesResult}>
        <Box display='flex' alignItems='center' justifyContent='space-between' my={1} className={classes.feesText}>
          <span>
            <FormattedMessage {...messages.registration_fees_of_property_details} />
          </span>

          <span>
            <FormattedMessage {...messages.AED_amount} values={{ num: feeCharges?.propertyRegFeeAmount }} />
          </span>
        </Box>
        {/* Notfication */}

        <NotficationGenerator classes={classes} Property />

        <Box display='flex' alignItems='center' justifyContent='space-between' my={1} className={classes.feesText}>
          <span>
            <FormattedMessage {...messages.registration_fees_of_rental_unit_details} />
          </span>
          <span>
            <FormattedMessage {...messages.AED_amount} values={{ num: feeCharges?.unitRegFeeAmount }} />
          </span>
        </Box>
        {/* Notfication */}

        <NotficationGenerator classes={classes} Unit />
      </Box>
    ) : (
      <Box className={classes.feesResult}>
        {/* Registration Fees of Property Details */}
        <RegFeesOfPropertyDetailsNotEditable showSmallTip classes={classes} feeCharges={feeCharges} />

        {/* Registration Fees of Rental Unit Details */}
        <RegFeesOfUnitDetailsNotEditable classes={classes} feeCharges={feeCharges} />
      </Box>
    );
  }
}
function RegFeesOfPropertyDetailsNotEditable({ classes, feeCharges, showSmallTip = false }) {
  return (
    <>
      <Box display='flex' alignItems='center' justifyContent='space-between' className={classNames(classes.feesHeader)}>
        <span>
          <FormattedMessage {...messages.registration_fees_of_property_details} />
        </span>
        <span className={classes.Totalprice}>
          <FormattedMessage {...messages.AED_amount} values={{ num: feeCharges?.propertyRegFeeAmount }} />
        </span>
      </Box>

      {showSmallTip && (
        <Box display='flex' alignItems='center' my={1} className={classes.feesTextSmall}>
          <ADGMImage name='InformationDarkGrey.svg' width='20px' alt='InfoIcon' />
          <Box component='span' mx={1}>
            {keyEmptyCheck('building_registration_fee_paid_by_developer')}
          </Box>
        </Box>
      )}
    </>
  );
}
function RegFeesOfUnitDetailsNotEditable({ classes, feeCharges }) {
  return (
    <>
      <Box display='flex' alignItems='center' justifyContent='space-between' className={classNames(classes.feesHeader)}>
        <span>
          <FormattedMessage {...messages.registration_fees_of_rental_unit_details} />
        </span>
        <span className={classes.Totalprice}>
          <FormattedMessage {...messages.AED_amount} values={{ num: feeCharges?.unitRegFeeAmount }} />
        </span>
      </Box>
      <Box display='flex' alignItems='center' my={1} className={classes.feesTextSmall}>
        <ADGMImage name='InformationDarkGrey.svg' width='20px' alt='InfoIcon' />
        <Box component='span' mx={1}>
          {feeCharges?.isVilla
            ? keyEmptyCheck('villa_registration_fees_paid_by_the_owner')
            : keyEmptyCheck('unit_registration_fee_paid_by_owner')}
        </Box>
      </Box>
    </>
  );
}
function NotficationGenerator({ classes, Property = false, Unit = false, Villa = false }) {
  function KeyName() {
    if (Property) return 'tawtheeq_registration_fees_property_hint';
    if (Unit) return 'tawtheeq_registration_fees_unit_hint';
    if (Villa) return 'register_villa_fee_paid_by_owner';
  }
  return (
    <Box mt={2}>
      <ADGMAlert visible noBackground={false} type='info' className={classes.fullWidth_Padding}>
        {keyEmptyCheck(KeyName())}
      </ADGMAlert>
    </Box>
  );
}

TawtheeqRegistrationFees.propTypes = {
  classes: PropTypes.object.isRequired,
  feeCharges: PropTypes.object.isRequired,
  isEditable: PropTypes.bool.isRequired,
  handleCheck: PropTypes.func.isRequired,
  registrationFeeDetails: PropTypes.object.isRequired,
  application: PropTypes.object.isRequired,
};
RegFeesOfPropertyDetailsNotEditable.propTypes = {
  classes: PropTypes.object.isRequired,
  feeCharges: PropTypes.object.isRequired,
  showSmallTip: PropTypes.bool,
};

RegFeesOfPropertyDetailsNotEditable.defaultProps = {
  showSmallTip: false,
};

RegFeesOfUnitDetailsNotEditable.propTypes = {
  classes: PropTypes.object.isRequired,
  feeCharges: PropTypes.object.isRequired,
};

NotficationGenerator.propTypes = {
  classes: PropTypes.object.isRequired,
  Property: PropTypes.bool,
  Unit: PropTypes.bool,
  Villa: PropTypes.bool,
};

NotficationGenerator.defaultProps = {
  Property: false,
  Unit: false,
  Villa: false,
};

export default withStyles(styles)(TawtheeqRegistrationFees);
